import React from "react";

const Footer = () => (
  <footer style={{ marginTop: 40, color: '#aaa' }}>
    <p>© 2025. TIIAME NRU</p>
  </footer>
);

export default Footer;
